var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "M4.595 8.827A.62.62 0 0 1 4.162 9a.62.62 0 0 1-.433-.173L.269 5.485a.866.866 0 0 1 0-1.256l.433-.418a.94.94 0 0 1 1.3 0l2.16 2.086L10 .26a.94.94 0 0 1 1.3 0l.433.419c.359.346.359.909 0 1.255z"
  })));
};
export default SvgCheck;